import React, {Component} from "react";
import '../EMR.css';
import ActiveDiagnosisTab from "./ActiveDiagnosisTab";
import InsuranceStatus from "./InsuranceStatus";
import ProcedureTables from "./ProcedureTables";
import RemotingService from "../../../../services/remoting-service/RemotingService";
import VisitNavigator from "../common/VisitNavigator";

export default class Diagnosis extends Component {

    constructor(props) {
        super(props);
        this.state = {
            index: props.currentVisitIndex
        };
    }

    componentDidMount() {
        this.retrieveInsuranceApprovalForVisit();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.currentVisit.id !== this.props.currentVisit.id) {
            this.setState({index: this.props.currentVisitIndex});
            this.retrieveInsuranceApprovalForVisit();
        }
        if (prevState.index !== this.state.index) {
            this.retrieveInsuranceApprovalForVisit();
        }
    }

    retrieveInsuranceApprovalForVisit = () => {
        const selectedVisit = this.props.visits[this.state.index];
        RemotingService.getRemoteCall(
            `api/insurance/coordinator/v2/insurance-approval/visit/${this.props.currentVisit.id}`,
            {visitId: selectedVisit.id},
            (insuranceApproval) => {
                this.setState({insuranceApproval});
            });
    }

    getApprovalDiagnosisCodes = () => {
        const diagnosisItems = this.state.insuranceApproval?.directBilling?.diagnosisGroup?.diagnosisItems || [];
        return diagnosisItems.map(diagnosisItem => diagnosisItem.code).filter(code => code);
    }

    render() {
        const selectedVisit = this.props.visits[this.state.index];
        const selectedDiagnosis = selectedVisit.diagnosis;
        const currentVisit = this.props.visits[this.props.currentVisitIndex];
        const currentDiagnosis = currentVisit.diagnosis;
        const isDirectBilling = this.state.insuranceApproval != null;

        return (
            <div>
                <VisitNavigator
                    visits={this.props.visits}
                    currentVisitIndex={this.props.currentVisitIndex}
                    selectedIndex={this.state.index}
                    onDateChange={(index) => {
                        this.setState({index: index});
                    }}
                />
                <div className={this.props.disabled ? "content-row disable-pointer" : "content-row"}>
                    <div className={"content-col-6"}>
                        <div className={"content-wrapper"}>
                            <ActiveDiagnosisTab diagnosis={currentDiagnosis}
                                                visits={this.props.visits}
                                                isDirectBilling={isDirectBilling}
                                                approvalDiagnosisCodes={this.getApprovalDiagnosisCodes()}
                                                currentVisitIndex={this.props.currentVisitIndex}
                                                selectedVisitIndex={this.state.index}
                                                disabled={this.props.disabled}/>
                        </div>
                    </div>

                    <div className={"content-col-6"}>
                        <div className={"content-wrapper"}>
                            <div className="content-label">Billing</div>
                            <InsuranceStatus diagnosis={currentDiagnosis}
                                             insuranceApproval={this.state.insuranceApproval}
                                             currentVisit={currentVisit}/>
                            <br/>
                            <br/>
                            <ProcedureTables diagnosis={currentDiagnosis}
                                             insurance={this.props.insurance}
                                             currentVisit={currentVisit}
                                             readOnly/>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
